import PropTypes from "prop-types"

import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom"
import TrayVariants from "./TrayVariants"
import Customization from "./Customization"
import TrayDesignerApp from "./TrayDesignerApp"

const Router = props => {
  return (
    <BrowserRouter basename="/tray-designer">
      <Switch>
        <Route exact path="/" component={TrayVariants} />
        <Route
          exact
          path="/customization"
          component={withAppProps(Customization, props)}
        />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  )
}

export const RouterPropTypes = {
  fetchImagesPath: PropTypes.string.isRequired,
}

Router.propTypes = {
  ...RouterPropTypes,
}
/**
 *
 * @param {*} WrappedComponent
 * @param {*} passedProps
 */
const withAppProps = (WrappedComponent, passedProps) => props => (
  <TrayDesignerApp>
    <WrappedComponent {...props} {...passedProps} />
  </TrayDesignerApp>
)

export default Router
